module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.5409f30b.png";